import { breakpoint, Heading, spacing } from '@digitools/honest-ui';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { TEALIUM_EVENT } from '../../../../constants/tealiumConstants';
import useAuthentication from '../../../../hooks/useAuthentication';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import useTealium from '../../../../hooks/useTealium';
import { getCustomerLogo } from './../../../../api/UiServiceApi';
import MessagesContainer from './Messages/MessagesContainer';
import QuickLinks from './QuickLinks';
const breakpointMdMaxPx = Number.parseFloat(breakpoint.lg) * 16 - 1;
const breakpointMdMaxQuery = `(max-width: ${breakpointMdMaxPx}px)`;
const CustomerBarContainer = styled('div') `
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${spacing.xs};
`;
const ActionsContainer = styled('div') `
    display: flex;
    align-items: center;
    gap: ${spacing.xl2};
`;
const CustomerBar = ({ landingPageResource }) => {
    const [customerLogo, setCustomerLogo] = useState('');
    const { authHeader, user } = useAuthentication();
    const { trackEvent } = useTealium();
    const isMobile = useMediaQuery(breakpointMdMaxQuery);
    const trackPageEvent = (eventName, eventAction) => {
        trackEvent({
            event_action: eventAction || TEALIUM_EVENT.EVENT_ACTION.BUTTON,
            event_name: eventName,
            event_type: TEALIUM_EVENT.EVENT_TYPE.CUSTOMER_ROLLUP_BAR,
        });
    };
    // TODO: rip out logo from baaaad old header implementation, should be added to config data in Config provider
    useEffect(() => {
        const fetchCustomerLogo = async () => {
            const results = await getCustomerLogo(authHeader(), user?.customerId);
            if (results && results.data && results.data.size > 0) {
                setCustomerLogo(URL.createObjectURL(results.data));
            }
        };
        fetchCustomerLogo();
    }, []);
    const customerName = user && (user.customerDisplayName ? user.customerDisplayName : user.customerInternalName);
    return (<CustomerBarContainer>
      <Heading as='h1' visualLevel='h4'>
        {customerName}
      </Heading>
      <ActionsContainer>
        {!isMobile && (<>
            <QuickLinks trackPageEvent={trackPageEvent}/>
            <MessagesContainer trackPageEvent={trackPageEvent} landingPageResource={landingPageResource}/>
          </>)}
        {customerLogo && (<img src={customerLogo} alt='' // decorative: customer name heading is next to logo
         style={{ maxHeight: spacing.xl2 }}/>)}
      </ActionsContainer>
    </CustomerBarContainer>);
};
export default CustomerBar;
